module.exports = __webpack_public_path__ + "img/Trending-UP.769560c9.svg";